if (!customElements.get('emz-article-link')) {
  customElements.define('emz-article-link', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const button = this.querySelector('[data-copy-article-link]');
      const status = this.querySelector('[data-copy-status]');
      const fallback = this.querySelector('[data-copy-fallback]');
      const input = fallback && fallback.querySelector('input');
      if (!button || !status || !fallback || !input) return;
      let url;
      try {
        url = new URL(this.dataset.articleUrl, window.location.origin);
        if (url.origin !== window.location.origin || !/^https?:$/.test(url.protocol) || url.username || url.password) return;
        if (!/\/blogs\/[^/]+\/[^/]+\/?$/.test(url.pathname)) return;
        url.search = '';
        url.hash = '';
      } catch (_) {
        return;
      }
      this.initialized = true;
      this.revision = 0;
      this.hidden = false;
      let copying = false;
      button.addEventListener('click', async () => {
        if (copying) return;
        const revision = this.revision;
        status.textContent = '';
        fallback.hidden = true;
        copying = true;
        button.setAttribute('aria-busy', 'true');
        try {
          if (!navigator.clipboard || !navigator.clipboard.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(url.href);
          if (this.isConnected && revision === this.revision) status.textContent = this.dataset.copied;
        } catch (_) {
          if (!this.isConnected || revision !== this.revision) return;
          input.value = url.href;
          fallback.hidden = false;
          status.textContent = this.dataset.copyFallback;
          if (document.activeElement === button) {
            input.focus();
            input.select();
          }
        } finally {
          copying = false;
          button.removeAttribute('aria-busy');
        }
      });
    }

    disconnectedCallback() {
      this.revision++;
    }
  });
}
